export default __webpack_public_path__ + "static/media/1985.e2721f15.jpg";